/**
 * Slider « Produits écoresponsables » (Ge-Ro) — section 4 de l'accueil.
 * Swiper chargé en global (init_swiper côté bloc quand >1 image).
 */
function initEcoSliders() {
  const sliders = document.querySelectorAll('.eco-swiper');
  if (!sliders.length || typeof window.Swiper === 'undefined') {
    return false;
  }

  sliders.forEach((el) => {
    if (el.dataset.swiperInit) return;
    el.dataset.swiperInit = '1';

    const root = el.closest('.eco-slider') || document;

    new window.Swiper(el, {
      slidesPerView: 1,
      speed: 500,
      spaceBetween: 20,
      navigation: {
        prevEl: root.querySelector('.eco-prev'),
        nextEl: root.querySelector('.eco-next'),
      },
      pagination: {
        el: root.querySelector('.eco-pagination'),
        clickable: true,
      },
    });
  });

  return true;
}

function boot() {
  if (!initEcoSliders()) {
    window.addEventListener('load', initEcoSliders, { once: true });
  }
}

if (document.readyState !== 'loading') {
  boot();
} else {
  document.addEventListener('DOMContentLoaded', boot);
}
